export const U2000UpdateIdInsideUrl = (navigate: any, currentPath: string, id: string | number): void => {
  const basePath = currentPath.split("/").slice(0, -1).join("/");
  navigate(`${basePath}/${id}`);
};

export const U2000GenerateUrlUUID = (): string => {
  return ([1e7].join("") + -1e3 + -4e3 + -8e3 + -1e11).replace(/[018]/g, (c) => (parseInt(c, 10) ^ (crypto.getRandomValues(new Uint8Array(1))[0] & (15 >> (parseInt(c, 10) / 4)))).toString(16));
};
